var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_setup.isShowReadStatus),expression:"isShowReadStatus"}],class:{
    'message-label': true,
    'unread': _setup.isUseUnreadStyle,
    'finger-point': _setup.isHoverFingerPointer,
  },on:{"click":_setup.openReadUserPanel}},[_c('span',[_vm._v(_vm._s(_setup.readStatusText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }